import { render, staticRenderFns } from "./ProductDetailsRedirection.vue?vue&type=template&id=72bab7ae&scoped=true"
import script from "./ProductDetailsRedirection.vue?vue&type=script&lang=js"
export * from "./ProductDetailsRedirection.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailsRedirection.vue?vue&type=style&index=0&id=72bab7ae&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bab7ae",
  null
  
)

export default component.exports